var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imgSrc)?_c('div',{staticClass:"HomeTechnology"},[_c('img',{attrs:{"src":_vm.imgSrc,"alt":""}}),(_vm.url)?_c('div',{staticClass:"click",on:{"click":_vm.handleJump}},[_c('span',[_vm._v("Explore more")]),_c('img',{attrs:{"src":require("@/assets/home/arraw_m.png"),"alt":""}})]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }